<template>
    <div class="qrbtn" @mouseenter="qrVisible=true" @mouseleave="qrVisible=false">
      <span class="sicon" ></span>
      <span class="txt_tip">移动端</span>
      <div class="qrPop" v-show="qrVisible">
        <div class="con">
          <img :src="qrImg" alt="">
        </div>
      </div>
    </div> 
</template>
<script>
import configs from '@/config/config'
export default {
  name: 'qrbtn',
  props: {
    
  },
  data(){
    return{
      qrImg: `/images/${process.env.NODE_ENV === 'production' ? qrImg : configs.qrImg}`,
      qrVisible:false
    }
  },
  methods:{
    showQr(){
      this.qrVisible=true
    }

  }
}
</script>